export const getFlagUrl = (code: string) => {
  return `${process.env.REACT_APP_UIKIT_CDN_URL}/flags/${code}.svg`
}
